import {LoggerService, LogCategory, LogLevel} from './logger.service';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment-wrapper';

@Injectable()
export class BrowserLoggerService extends LoggerService {
    protected isEnabled(category: LogCategory, level: LogLevel) {
        if (level === 'dbug' || (environment.production && category === 'missingTranslation')) return false;

        switch (category) {
            default:
                return true;
        }
    }
}
